import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {
  title: string;
  msg;

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    title: string,
    titleBody: string,
    body: string,
    warning: string
  }, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.data.title ? this.title = this.data.title : 'Confirm dialog';
    this.data.titleBody ? this.msg = this.transform(this.data.titleBody) : 'Are you sure?';
  }

  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
